import React, { useState, useRef, useEffect } from 'react';
import { DayPicker } from 'react-day-picker';
import { format } from 'date-fns';
import { fr } from 'date-fns/locale';
import 'react-day-picker/dist/style.css'; // ⚠️ Inclut le CSS officiel
import './DateInput.css'; // CSS personnalisé

const DateInput = ({ selected, onSelect, placeholder }) => {
  const [showPicker, setShowPicker] = useState(false);
  const ref = useRef(null);

  // Fermer le calendrier si clic à l'extérieur
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (ref.current && !ref.current.contains(event.target)) {
        setShowPicker(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  return (
    <div className="date-input-wrapper" ref={ref} style={{ position: 'relative', display: 'inline-block' }}>
      <input
        type="text"
        readOnly
        value={selected ? format(selected, 'dd/MM/yyyy') : ''}
        placeholder={placeholder}
        onClick={() => setShowPicker(!showPicker)}
        className="form-control"
        style={{ cursor: 'pointer', backgroundColor: 'white' }}
      />
      {showPicker && (
        <div className="daypicker-container">
          <DayPicker
            mode="single"
            selected={selected}
            onSelect={(day) => {
              onSelect(day);
              setShowPicker(false);
            }}
            locale={fr}
            showOutsideDays
          />
        </div>
      )}
    </div>
  );
};

export default DateInput;
